import * as React from "react";
import "antd/dist/reset.css"; // AntD v5+

// CSS & SCSS
import "./assets/fonts/inter.css";
import "./assets/fonts/material.css";
import "./assets/fonts/icofont/icofont.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/sass/styles.scss";

// JS & COMPONENTS
import "./i18n";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "./context/Themes";
import { FormProvider } from "./context/FormContext";
import { SidebarProvider } from "./context/Sidebar";
import { LoaderProvider } from "./context/Preloader";
import { TranslatorProvider } from "./context/Translator";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { LoginPage, RegisterPage, ForgotPasswordPage, OnlyLogin } from "./pages/auth";
import {
	OverviewPage,
	DocumentationPage,
	ChangeLogPage,
	ErrorPage,
} from "./pages/others";
import {
	AvatarPage,
	AlertPage,
	ButtonPage,
	ChartPage,
	TablePage,
	FieldPage,
	HeadingPage,
	ColorPage,
} from "./pages/ui";
import {
	EcommercePage,
	AnalyticsPage,
	CRMPage,
	UserListPage,
	UserProfilePage,
	MyAccountPage,
	ProductListPage,
	ProductViewPage,
	ProductUploadPage,
	InvoiceListPage,
	InvoiceDetailsPage,
	OrderListPage,
	MessagePage,
	NotificationPage,
	BlankPage,
	SettingsPage,
	DraftForm,
	AssessmentForm,
} from "./pages/main";

//context providers

import CreateUser from "./pages/main/Users/CreateUser";
import EditUser from "./pages/main/Users/EditUser";
import ListUser from "./pages/main/Users/LIstUsers";
import ListFamilyDonor from "./pages/main/Family Donor/ListFamilyDonor";
import AddFamilyDonor from "./pages/main/Family Donor/AddFamilyDonor";
import EditFamilyDonor from "./pages/main/Family Donor/EditFamilyDonor";
import ViewUsetDetails from "./pages/main/Users/ViewUsetDetails";
import AddReligiousAssociation from "./pages/main/ReligiousAssociation/AddReligiousAssociation";
import Dashboard from "./pages/main/Dashboard";
import DashboardCountList from "./pages/main/DashboardCountList";
import DraftList from "./pages/main/draft-list";
import PendingAttested from "./pages/main/pending-attested";
import AddMedicalCare from "./pages/main/MedicalCare/AddMedicalCare";
import AddNewPrayer from "./pages/main/Prayer Request/AddNewPrayer";
import CreateDonor from "./pages/main/Create Donor/CreateDonor";
import AllPrayerRequests from "./pages/main/Prayer Request/AllPrayerRequests";
import FamilyFilter from "./pages/main/Data Filters/FamilyFilter";
import AllFilters from "./pages/main/Data Filters/AllFilters";
import AllDonor from "./pages/main/Create Donor/AllDonor";
import AllMedicalCare from "./pages/main/MedicalCare/AllMedicalCare";
import AllVocationalTraining from "./pages/main/VocationalTraining/AllVocationalTraining";
import AddVocationalTraining from "./pages/main/VocationalTraining/AddVocationalTraining";
import ViewVocationalTraining from "./pages/main/VocationalTraining/ViewVocationalTraining";
import EditTraining from "./pages/main/VocationalTraining/EditVocationalTrainings";
import { AuthProvider } from "./context/AuthContext";
import { ProtectedRoute } from "./pages/auth/ProtectedRoute";
import AddNewFollowUp from "./pages/main/FamilyFollowUp/AddNewFollowUp";
import AllFollowUps from "./pages/main/FamilyFollowUp/AllFollowups";
import {
	ValidationContext,
	ValidationProvider,
} from "./context/ValidationContext";
import { AxiosProvider } from "./context/AxiosProvider";

import VerifiedFamilies from "./pages/main/VerifiedFamilies";
import SidenavPermissions from "./components/SidenavPermissions";
import FamilyFundForecast from "./pages/main/Finances/FamilyFundForecast";
import EditFamliyFundForecast from "./pages/main/Finances/EditFamilyFundForecast";
import AddNewBrickKiln from "./pages/main/BrickKiln/AddNewBrickkiln";
import AllBrickKilns from "./pages/main/BrickKiln/AllBrickKilns";
import EditBrickKiln from "./pages/main/BrickKiln/EditBrickkiln";
import AllRescuedFamilies from "../src/pages/main/FamilyRescued/AllRecuedFamilies";
import FamilyRescueForm from "./pages/main/FamilyRescued/FamilyRescueForm";
import CompleteFamilyProfile from "./pages/CompleteFamilyProfile";
import FamilyReportPage from "./pages/main/FamilyReportPage";
import EditDraft from "./pages/main/editDraft";
import VerifyDraft from "./pages/main/verifyDraft";
import FundsDashboard from "./pages/main/Finances/FundsDashboard";
import AllFamilyFundForecast from "./pages/main/Finances/AllFamilyFundForecast";
import DraftDistribution from "./pages/main/DataDistribution/draftDistribution";
import RescueDistribution from "./pages/main/DataDistribution/verifiedDistribution";
import RescuedDistribution from "./pages/main/DataDistribution/rescuesDistribution";
import DistributeDashboard from "./pages/main/DataDistribution/DistributionDashboard";
import VerifiedList from "./pages/main/verified-list";
import FollowupDistribution from "./pages/main/DataDistribution/followupDistribution";
import FamilyListPage from "./pages/main/DataDistribution/DistributedList";
import AssesmentDashboardList from "./pages/main/AssesmentDashboard/AssesmentDashboardList";
import AssesmentDashboard from "./pages/main/AssesmentDashboard/DashboardAssesment";
import PersonReportPage from "./pages/main/AssesmentDashboard/PersonReportPage";

//groups
import ACTgroups from "../src/components/Groups/GroupDashboard";
import GroupsList from "../src/components/Groups/GroupsList";
import ViewGroupMembers from "../src/components/Groups/ViewGroupMembers";
import AllFamilyFilter from "./pages/main/Data Filters/AllFilters";
import FilteredFamilies from "./pages/main/Data Filters/FilteredFamilies";
import ViewFollowUp from "./pages/main/FamilyFollowUp/ViewFollowUp";
import SearchPerson from "./pages/main/search/Search";

import AddSchoolEnrollment from "./pages/main/SchoolEnrollment/AddSchoolEnrollment";
import SchoolEnrollments from "./pages/main/SchoolEnrollment/AllSchoolEnrollment";

import AllReligiousAssociations from "./pages/main/ReligiousAssociation/AllReligiousAssociation";
import ViewReligiousAffiliation from "./pages/main/ReligiousAssociation/ViewReligiousAffiliation";
import EditReligiousAffiliation from "./pages/main/ReligiousAssociation/EditReligiousAffiliation";
import EditMedicalCare from "./pages/main/MedicalCare/EditMedicalCare";
import ViewMedicalCare from "./pages/main/MedicalCare/ViewMedicalCare";
import EditSchoolEnrollment from "./pages/main/SchoolEnrollment/EditSchoolEnrollment";
import ViewSchoolEnrollment from "./pages/main/SchoolEnrollment/ViewSchoolEnrollment";

const router = createBrowserRouter([
	// MAIN PAGES
	{ path: "/ecommerce", element: <EcommercePage /> },
	{ path: "/analytics", element: <AnalyticsPage /> },
	{ path: "/crm", element: <CRMPage /> },
	{ path: "/forgot-password", element: <ForgotPasswordPage /> },
	{ path: "/register", element: <RegisterPage /> },
	{ path: "/onlylogin/:otp", element: <OnlyLogin /> },
	{ path: "/login", element: <LoginPage /> },
	{ path: "/user-list", element: <UserListPage /> },
	{ path: "/user-profile", element: <UserProfilePage /> },
	{ path: "/my-account", element: <MyAccountPage /> },
	{ path: "/product-list", element: <ProductListPage /> },
	{ path: "/product-view", element: <ProductViewPage /> },

	{ path: "/product-upload", element: <ProductUploadPage /> },
	{ path: "/invoice-list", element: <InvoiceListPage /> },
	{ path: "/invoice-details", element: <InvoiceDetailsPage /> },
	{ path: "/order-list", element: <OrderListPage /> },
	{ path: "/message", element: <MessagePage /> },
	{ path: "/notification", element: <NotificationPage /> },
	{ path: "/blank-page", element: <BlankPage /> },
	{ path: "/settings", element: <SettingsPage /> },

	// UI PAGES
	{ path: "/avatars", element: <AvatarPage /> },
	{ path: "/alerts", element: <AlertPage /> },
	{ path: "/buttons", element: <ButtonPage /> },
	{ path: "/charts", element: <ChartPage /> },
	{ path: "/tables", element: <TablePage /> },
	{ path: "/fields", element: <FieldPage /> },
	{ path: "/headings", element: <HeadingPage /> },
	{ path: "/colors", element: <ColorPage /> },

	// OTHER PAGES

	{
		path: "/",
		element: (
			<ProtectedRoute>
				<Dashboard />
			</ProtectedRoute>
		),
	},
	{
		path: "/dashboard-count-list",
		element: (
			<ProtectedRoute>
				<DashboardCountList />{" "}
			</ProtectedRoute>
		),
	},

	{
		path: "/darft-list",
		element: (
			<ProtectedRoute>
				<DraftList />
			</ProtectedRoute>
		),
	},
	{
		path: "/pending-attested",
		element: (
			<ProtectedRoute>
				<PendingAttested />
			</ProtectedRoute>
		),
	},
	{
		path: "/verified-families",
		element: (
			<ProtectedRoute>
				<VerifiedFamilies />
			</ProtectedRoute>
		),
	},

	{
		path: "/add-new-family",
		element: (
			<ProtectedRoute>
				<DraftForm />
			</ProtectedRoute>
		),
	},
	{
		path: "/family-assesment/:person_id",
		element: (
			<ProtectedRoute>
				<AssessmentForm />
			</ProtectedRoute>
		),
	},
	{
		path: "/edit-family/:fsf_id",
		element: (
			<ProtectedRoute>
				<EditDraft />
			</ProtectedRoute>
		),
	},
	{
		path: "/verify-family/:fsf_id",
		element: (
			<ProtectedRoute>
				<VerifyDraft />
			</ProtectedRoute>
		),
	},
	{
		path: "/darft-list",
		element: (
			<ProtectedRoute>
				<DraftList />
			</ProtectedRoute>
		),
	},

	//Data Distribution
	{
		path: "/distribute-for-verification",
		element: (
			<ProtectedRoute>
				<DraftDistribution />{" "}
			</ProtectedRoute>
		),
	},
	{
		path: "/distribute-for-rescue",
		element: (
			<ProtectedRoute>
				<RescueDistribution />{" "}
			</ProtectedRoute>
		),
	},
	{
		path: "/distribute-for-business",
		element: (
			<ProtectedRoute>
				<RescuedDistribution />{" "}
			</ProtectedRoute>
		),
	},
	{
		path: "/distribute-for-followup",
		element: (
			<ProtectedRoute>
				<FollowupDistribution />{" "}
			</ProtectedRoute>
		),
	},
	{
		path: "/distribution-dashboard",
		element: (
			<ProtectedRoute>
				<DistributeDashboard />{" "}
			</ProtectedRoute>
		),
	},
	{
		path: "/distibuted-family-list/:key",
		element: (
			<ProtectedRoute>
				<FamilyListPage />{" "}
			</ProtectedRoute>
		),
	},

	{
		path: "/documentation",
		element: (
			<ProtectedRoute>
				<DocumentationPage />{" "}
			</ProtectedRoute>
		),
	},
	{
		path: "/changelog",
		element: (
			<ProtectedRoute>
				<ChangeLogPage />{" "}
			</ProtectedRoute>
		),
	},
	{
		path: "/error",
		element: (
			<ProtectedRoute>
				<ErrorPage />{" "}
			</ProtectedRoute>
		),
	},

	//Medical Care
	{
		path: "/add-medical-care",
		element: (
			<ProtectedRoute>
				<AddMedicalCare />{" "}
			</ProtectedRoute>
		),
	},
	{
		path: "/list-medical-care",
		element: (
			<ProtectedRoute>
				<AllMedicalCare />{" "}
			</ProtectedRoute>
		),
	},
	{
		path: "/medical-care/edit/:id",
		element: (
			<ProtectedRoute>
				<EditMedicalCare />{" "}
			</ProtectedRoute>
		),
	},
	{
		path: "/medical-care/view/:id",
		element: (
			<ProtectedRoute>
				<ViewMedicalCare />{" "}
			</ProtectedRoute>
		),
	},

	//VOCATIONAL TRAINING
	{
		path: "/add-new-vocational-training",
		element: (
			<ProtectedRoute>
				<AddVocationalTraining />{" "}
			</ProtectedRoute>
		),
	},
	{
		path: "/all-vocational-training",
		element: (
			<ProtectedRoute>
				<AllVocationalTraining />{" "}
			</ProtectedRoute>
		),
	},
	{
		path: "/vocational-training/:id",
		element: (
			<ProtectedRoute>
				<ViewVocationalTraining />{" "}
			</ProtectedRoute>
		),
	},
	{
		path: "/edit-vocational-training/:id",
		element: (
			<ProtectedRoute>
				<EditTraining />{" "}
			</ProtectedRoute>
		),
	},

	//School Enrollment
	{
		path: "/add-new-school-enrollment",
		element: (
			<ProtectedRoute>
				<AddSchoolEnrollment />{" "}
			</ProtectedRoute>
		),
	},
	{
		path: "/all-school-enrollment",
		element: (
			<ProtectedRoute>
				<SchoolEnrollments />{" "}
			</ProtectedRoute>
		),
	},
	{
		path: "/edit-school-enrollment/:id",
		element: (
			<ProtectedRoute>
				<EditSchoolEnrollment/>{" "}
			</ProtectedRoute>
		),
	},
	{
		path: "/view-school-enrollment/:id",
		element: (
			<ProtectedRoute>
				<ViewSchoolEnrollment/>{" "}
			</ProtectedRoute>
		),
	},
	//RELIGIOUS ASSOCIATION
	{
		path: "/add-new-spiritual-record",
		element: (
			<ProtectedRoute>
				<AddReligiousAssociation />{" "}
			</ProtectedRoute>
		),
	},
	{
		path: "/all-spiritual-record",
		element: (
			<ProtectedRoute>
				<AllReligiousAssociations />{" "}
			</ProtectedRoute>
		),
	},
	{
		path: "/religious-affiliation/:id",
		element: (
			<ProtectedRoute>
				<ViewReligiousAffiliation />{" "}
			</ProtectedRoute>
		),
	},
	{
		path: "/edit-religious-affiliation/:id",
		element: (
			<ProtectedRoute>
				<EditReligiousAffiliation />{" "}
			</ProtectedRoute>
		),
	},
	//PRAYER REQUESTS
	{
		path: "/add-new-prayer",
		element: (
			<ProtectedRoute>
				<AddNewPrayer />{" "}
			</ProtectedRoute>
		),
	},
	{
		path: "/all-prayer-requests",
		element: (
			<ProtectedRoute>
				<AllPrayerRequests />{" "}
			</ProtectedRoute>
		),
	},

	//CREATE DONOR
	{
		path: "/create-donor",
		element: (
			<ProtectedRoute>
				<CreateDonor />{" "}
			</ProtectedRoute>
		),
	},
	{
		path: "/all-donor",
		element: (
			<ProtectedRoute>
				<AllDonor />{" "}
			</ProtectedRoute>
		),
	},

	//DATA FILTERS
	{
		path: "/filter-families",
		element: (
			<ProtectedRoute>
				<AllFamilyFilter />{" "}
			</ProtectedRoute>
		),
	},
	{
		path: "/filtered-families",
		element: (
			<ProtectedRoute>
				<FilteredFamilies />{" "}
			</ProtectedRoute>
		),
	},

	//FAMILY FOLLOW UP
	{
		path: "/add-follow-up",
		element: (
			<ProtectedRoute>
				<AddNewFollowUp />{" "}
			</ProtectedRoute>
		),
	}, {
		path: "/edit-follow-up/:id",
		element: (
			<ProtectedRoute>
				<AddNewFollowUp />{" "}
			</ProtectedRoute>
		),
	},
	{
		path: "/view-follow-up/:id",
		element: (
			<ProtectedRoute>
				<ViewFollowUp />{" "}
			</ProtectedRoute>
		),
	},

	{
		path: "/family-follow-ups",
		element: (
			<ProtectedRoute>
				<AllFollowUps />{" "}
			</ProtectedRoute>
		),
	},

	//FINANCES

	{
		path: "/verified-list",
		element: (
			<ProtectedRoute>
				<VerifiedList />{" "}
			</ProtectedRoute>
		),
	},
	{
		path: "/family-fund-forecast",
		element: (
			<ProtectedRoute>
				<FamilyFundForecast />{" "}
			</ProtectedRoute>
		),
	},
	{
		path: "/family-forecast",
		element: (
			<ProtectedRoute>
				<AllFamilyFundForecast />{" "}
			</ProtectedRoute>
		),
	},
	{
		path: "/funds-dashboard",
		element: (
			<ProtectedRoute>
				<FundsDashboard />{" "}
			</ProtectedRoute>
		),
	},
	{
		path: "/edit-family-fund-forecast/:id",
		element: (
			<ProtectedRoute>
				<EditFamliyFundForecast />{" "}
			</ProtectedRoute>
		),
	},

	//User
	{
		path: "/create-user",
		element: (
			<ProtectedRoute>
				<CreateUser />{" "}
			</ProtectedRoute>
		),
	},
	{
		path: "/edit-user/:id",
		element: (
			<ProtectedRoute>
				<EditUser />{" "}
			</ProtectedRoute>
		),
	},
	{
		path: "/list-user",
		element: (
			<ProtectedRoute>
				<ListUser />{" "}
			</ProtectedRoute>
		),
	},
	{
		path: "/user-details/:id",
		element: (
			<ProtectedRoute>
				<ViewUsetDetails />{" "}
			</ProtectedRoute>
		),
	},

	// Family Donor
	{
		path: "/create-family-donor",
		element: (
			<ProtectedRoute>
				<AddFamilyDonor />{" "}
			</ProtectedRoute>
		),
	},
	{
		path: "/edit-family-donor/:id",
		element: (
			<ProtectedRoute>
				<EditFamilyDonor />{" "}
			</ProtectedRoute>
		),
	},
	{
		path: "/list-family-donor",
		element: (
			<ProtectedRoute>
				<ListFamilyDonor />{" "}
			</ProtectedRoute>
		),
	},

	//BRICKKILNS
	{
		path: "/add-new-brickkiln",
		element: (
			<ProtectedRoute>
				<AddNewBrickKiln />{" "}
			</ProtectedRoute>
		),
	},
	{
		path: "/edit-brickkiln/:id",
		element: (
			<ProtectedRoute>
				<EditBrickKiln />{" "}
			</ProtectedRoute>
		),
	},
	{
		path: "/all-brickkiln",
		element: (
			<ProtectedRoute>
				<AllBrickKilns />{" "}
			</ProtectedRoute>
		),
	},

	//ALL RESCUED FAMILIES
	{
		path: "/all-rescued-families",
		element: (
			<ProtectedRoute>
				<AllRescuedFamilies />{" "}
			</ProtectedRoute>
		),
	},
	{
		path: "/family-rescue-form/:id?",
		element: (
			<ProtectedRoute>
				<FamilyRescueForm />{" "}
			</ProtectedRoute>
		),
	},

	//ALL COMPLETE FAMILIES FOLLOW UP
	{
		path: "/complete-family-profile",
		element: (
			<ProtectedRoute>
				<CompleteFamilyProfile />{" "}
			</ProtectedRoute>
		),
	},

	{
		path: "/family-report/:fsf_num",
		element: (
			<ProtectedRoute>
				<FamilyReportPage />{" "}
			</ProtectedRoute>
		),
	},

	{
		path: "/act-groups-dashboard",
		element: (
			<ProtectedRoute>
				<ACTgroups />{" "}
			</ProtectedRoute>
		),
	},
	{
		path: "/act-group-details/:key",
		element: (
			<ProtectedRoute>
				<GroupsList />{" "}
			</ProtectedRoute>
		),
	},
	{
		path: "/view-group-members/:id",
		element: (
			<ProtectedRoute>
				<ViewGroupMembers />
			</ProtectedRoute>
		),
	},
	//   { path: "/distribute-for-verification", element: (<ProtectedRoute> <DraftDistribution /> </ProtectedRoute>) },
	// { path: "/distribute-for-rescue", element: (<ProtectedRoute> <RescueDistribution /> </ProtectedRoute>) },
	// { path: "/distribute-for-business", element: (<ProtectedRoute> <RescuedDistribution /> </ProtectedRoute>) },
	// { path: "/distribute-for-followup", element: (<ProtectedRoute> <FollowupDistribution /> </ProtectedRoute>) },
	// { path: "/distribution-dashboard", element: (<ProtectedRoute> <DistributeDashboard /> </ProtectedRoute>) },
	// { path: "/distibuted-family-list/:key", element: (<ProtectedRoute> <FamilyListPage /> </ProtectedRoute>) },

	// Assesment record
	{
		path: "/assesment-dashboard-list/:key",
		element: (
			<ProtectedRoute>
				<AssesmentDashboardList />
			</ProtectedRoute>
		),
	},
	{
		path: "/assesment-dashboard",
		element: (
			<ProtectedRoute>
				<AssesmentDashboard />
			</ProtectedRoute>
		),
	},
	{
		path: "/person-report-page",
		element: (
			<ProtectedRoute>
				<PersonReportPage />{" "}
			</ProtectedRoute>
		),
	},
	{
		path: "/search-family",
		element: (
			<ProtectedRoute>
				<SearchPerson />
			</ProtectedRoute>
		),
	},
	{
		path: "/*",
		element: (
			<ProtectedRoute>
				<ErrorPage />{" "}
			</ProtectedRoute>
		),
	},
]);

createRoot(document.getElementById("root")).render(
	<ThemeProvider>
		<LoaderProvider>
			<TranslatorProvider>
				<SidebarProvider>
					<AuthProvider>
						<ValidationProvider>
							<AxiosProvider>
								<FormProvider>
									{/* Wrap the app with FormProvider */}
									<RouterProvider router={router} />
								</FormProvider>
							</AxiosProvider>
						</ValidationProvider>
					</AuthProvider>
				</SidebarProvider>
			</TranslatorProvider>
		</LoaderProvider>
	</ThemeProvider>
);
